import styled, { SimpleInterpolation, css } from "styled-components";
import {
  DrawerPlacementType,
  DragButtonPlacementMap,
  DragButtonWrapperPlacementMap,
} from "../../constants";

const getCloseIconPosition = (type: string) => {
  switch (type) {
    case "border-title":
      return css`
        top: 8px;
        right: 16px;
      `;
    default:
      return css`
        top: 20px;
        right: 16px;
      `;
  }
};

export const DrawerWrapper = styled.div<{
  customCSS: SimpleInterpolation;
  width?: number;
  $mask?: boolean;
  zIndex?: number;
}>`
  position: fixed;
  z-index: ${(p) => p.zIndex || 1050};
  width: ${(p) => (p.width && !p.$mask ? `${p.width}px` : "100%")};
  height: 100%;
  right: 0;
  top: 0;
  ${(p) => p.customCSS};
`;

export const DrawerMask = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1050;
  background: var(--task-eva-drawer-color-bg-mask);
`;
export const DrawerContent = styled.div<{
  placement: DrawerPlacementType;
  width?: number;
}>`
  position: absolute;
  z-index: 1050;
  background-color: var(--task-eva-modal-bg);
  box-shadow: ${(p) => `var(--task-eva-drawer-box-shadow-${p.placement})`};
  width: ${(p) => (p.width ? `${p.width}px` : "400px")};
  height: 100%;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  overflow: hidden;
  ${(p) => {
    switch (p.placement) {
      case DrawerPlacementType.Top:
        return css`
          top: 0;
        `;
      case DrawerPlacementType.Bottom:
        return css`
          bottom: 0;
        `;
      case DrawerPlacementType.Left:
        return css`
          left: 0;
        `;
      case DrawerPlacementType.Right:
        return css`
          right: 0;
        `;
    }
  }}
`;

export const ModalInnerHeader = styled.div`
  background-color: var(--task-eva-drawer-color-bg-header);
  color: var(--task-eva-text-color-1);
  text-align: left;
`;

export const DragButtonWrapper = styled.div<{
  placement: DrawerPlacementType;
}>`
  position: absolute;
  z-index: 1050;
  ${(p) => DragButtonWrapperPlacementMap.get(p.placement)};
  .task-eva-drag-button {
    border-radius: 10px;
    position: absolute;
    background-color: var(--task-eva-drawer-drag-button-bg);
    ${(p) => DragButtonPlacementMap.get(p.placement)};
  }
`;

export const CloseIconWrapper = styled.div<{ type: string }>`
  position: absolute;
  cursor: pointer;
  z-index: 1050;
  ${(p) => getCloseIconPosition(p.type)};
`;
